export default "__VITE_ASSET__B6U5xAdT__"